module.exports = __webpack_public_path__ + "img/location-icon.198a5437.svg";